// Import necessary libraries and components
import React from 'react';

// AppWrap is a Higher Order Component (HOC) that wraps a given component with additional elements
// and styles, such as SocialMedia, copyright, and NavigationDots.
// It takes a Component, an idName, and classNames as arguments.
const AppWrap = (Component, idName, classNames) => function HOC() {
  return (
    // Create a div with the given idName and classNames
    <div id={idName} className={`app__container ${classNames}`}>
        <div className='app__wrapper app__flex'>
             {/* Render the passed Component */}
            <Component />
             {/* Add a copyright div with two paragraphs */}
             
        </div>
    </div>
  );
};

// Export the AppWrap HOC
export default AppWrap;
